/*
 * Module lấy dữ liệu bảng AccountObjectGroup
 */
import api from "@/apis/AccountObjectGroupAPI";
import Crud from "./crud-base";
var crud = new Crud("AccountObjectGroup", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "AccountObjectGroupID",
      code: "AccountObjectGroupCode",
      name: "AccountObjectGroupName",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
